import { createProvider } from '@nvision/services/data-provider';

import * as api from './api';
import { normalizeTransportationGroupsList } from './normalize';

export const fetchTransportationGroupsList = createProvider(api.fetchTransportationGroupsList)
  .andThen((res) => normalizeTransportationGroupsList(res))
  .andCatch((error) => {
    if (error instanceof Error && error.name === 'AbortError') {
      console.warn('Fetch list aborted');
    } else {
      console.error('Fetch list was failed:', error);
    }

    throw error;
  });
